"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchProperties = exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var switchColors = {
  offBackground: _baseColors["default"].platinum,
  onBackground: _baseColors["default"].denim,
  toggler: _baseColors["default"].white
};
var switchProperties = {
  large: {
    width: '50px',
    height: '26px',
    radius: '1px',
    circle: {
      height: '18px',
      width: '18px'
    },
    activeWidth: '22px'
  },
  small: {
    height: '15px',
    width: '26px',
    radius: '1px',
    activeWidth: '15px',
    circle: {
      height: '12px',
      width: '12px'
    }
  }
};
exports.switchProperties = switchProperties;
var _default = switchColors;
exports["default"] = _default;